import * as React from "react";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import Button from "@mui/material/Button";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import InboxIcon from "@mui/icons-material/MoveToInbox";
import MailIcon from "@mui/icons-material/Mail";
import MapIcon from "@mui/icons-material/Map";
import { Collapse, Grid } from "@mui/material";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowLeftIcon from "@mui/icons-material/ArrowLeft";
import { useQueryClient } from "react-query";
import { TREE_MAP } from "../../config/cacheKey";
import { Tree } from "../../models/map.model";
import ProvinceMap from "./sticky/provinceMap";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";

type Anchor = "left";

export default function MapSideMenu(props: any) {
  const queryClient = useQueryClient();

  const tree_map = queryClient.getQueryData<Tree>(TREE_MAP);
  const [state, setState] = React.useState({
    left: false,
  });
  // const [openCollapseCity, setOpenCollapseCity] = React.useState(false);
  // const [openCollapseSupp, setOpenCollapseSupp] = React.useState(false);
  const toggleDrawer = (anchor: Anchor, open: boolean) => (
    event: React.KeyboardEvent | React.MouseEvent
  ) => {
    // if (
    //   event.type === "keydown" &&
    //   ((event as React.KeyboardEvent).key === "Tab" ||
    //     (event as React.KeyboardEvent).key === "Shift")
    // ) {
    //   return;
    // }

    setState({ ...state, [anchor]: open });
  };
  const hideSide = () => {
    props.setMenuSide((prev: any) => !prev);
    props.setFlyToLoc({ lat: 0, lng: 0 });
  };
  var sortedDataProvince = tree_map?.provinces?.sort(
    (a, b) => b.totalAmount! - a.totalAmount!
  );
  return (
    <div>
      <>
        <Box sx={{ height: "20%" }}>
          <Grid container xs={12} spacing={1} className="mapDrawer colorFFF">
            <Grid
              item
              xs={12}
              className=" mbottom5 cursorPointer mTop5 "
              onClick={hideSide}
            >
              <b className="colorFFF">
                {" "}
                &nbsp;&nbsp; <CloseIcon style={{ color: "#fff" }} />
              </b>
            </Grid>
            <Grid
              className="borderBottomDrawer mbottom20 mTop10 fontWeight "
              container
              spacing={2}
              item
            >
              <Grid item xs={5} className="centerDrawerMap">
                &nbsp;&nbsp; تعداد کل: &nbsp;
                {tree_map ? tree_map!.totalCount : null} &nbsp;|
              </Grid>
              <Grid item xs={7} className="centerDrawerMap">
                مبلغ{" "}
                {tree_map ? (
                  <>{tree_map!.totalAmount?.toLocaleString("fa")} ریال</>
                ) : null}
              </Grid>
              {/* <Grid item xs={1}></Grid> */}
            </Grid>
            {tree_map?.provinces?.map((province: any) => (
              <ProvinceMap
                province={province}
                setFlyToLoc={props.setFlyToLoc}
              />
            ))}
          </Grid>
        </Box>
        <Box>
          <Grid item xs={5} className="fixedMenu">
            {/* <MenuIcon
              style={{ color: "#fff", width: "30px", height: "30px" }}
              onClick={hideSide}
            /> */}
            {props.child}
          </Grid>
        </Box>
      </>
    </div>
  );
}
